import { render, staticRenderFns } from "./ViqReportOutlineEditor.vue?vue&type=template&id=61079a29&scoped=true"
import script from "./ViqReportOutlineEditor.vue?vue&type=script&lang=js"
export * from "./ViqReportOutlineEditor.vue?vue&type=script&lang=js"
import style0 from "./ViqReportOutlineEditor.vue?vue&type=style&index=0&id=61079a29&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61079a29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61079a29')) {
      api.createRecord('61079a29', component.options)
    } else {
      api.reload('61079a29', component.options)
    }
    module.hot.accept("./ViqReportOutlineEditor.vue?vue&type=template&id=61079a29&scoped=true", function () {
      api.rerender('61079a29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqReportOutlineEditor.vue"
export default component.exports